import { Stack, ToggleButtonGroup, Typography } from '@mui/material';

import _ from 'lodash';
import BasicDatePicker from '../../../../components/select/DatePicker';
import {
  InspectionStatus,
  InspectionToggleButton,
  StatusToggleButton,
} from '../../../../components/style/ButtonStyle';
import { FormLabelText } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import {
  A,
  B,
  C,
  OneStar,
  ThreeStar,
  TwoStar,
} from '../../../../layouts/dashboard/nav/IconButton';
import { TextAreaInput } from '../FacilityFormPage/CommonForm';

export function InspectionInputs({
  form,
  date,
  setDate,
  buttonWidth = '100%',
}: any) {
  const handleFormat = (
    event: React.MouseEvent<HTMLElement>,
    newFormats: string[],
  ) => {
    form.setValue('inspectionResult', newFormats);
  };
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    form.setValue('inspectionScore', newAlignment);
  };

  const [getStatusesResult] = useAuthAxios(
    {
      method: 'GET',
      url: '/api/v1/inspectionResultType',
    },
    { manual: false },
  );
  const statuses = _.get(getStatusesResult, 'response.data');

  return (
    <>
      <Stack spacing={1}>
        <FormLabelText>
          점검일자<span>*</span>
        </FormLabelText>
        <BasicDatePicker date={date} setDate={setDate} />
      </Stack>
      <Stack spacing={1}>
        <FormLabelText>
          점검상태<span>*</span>
        </FormLabelText>
        <ToggleButtonGroup
          orientation="vertical"
          color="primary"
          value={form.watch('inspectionScore')}
          exclusive
          onChange={handleChange}
          sx={{ width: '100%' }}
        >
          {[
            { value: 'A', icon: <A />, label: '양호', star: <ThreeStar /> },
            { value: 'B', icon: <B />, label: '주의', star: <TwoStar /> },
            { value: 'C', icon: <C />, label: '불량', star: <OneStar /> },
          ].map(check => (
            <InspectionToggleButton value={check?.value} key={check?.value}>
              <InspectionStatus>
                <Typography fontSize="16px" fontWeight={500}>
                  {check?.icon}&nbsp; {check?.label}
                </Typography>
                {check?.star}
              </InspectionStatus>
            </InspectionToggleButton>
          ))}
        </ToggleButtonGroup>
      </Stack>
      <Stack spacing={1}>
        <FormLabelText>상태비고</FormLabelText>
        <ToggleButtonGroup
          value={form.watch('inspectionResult')}
          onChange={handleFormat}
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'auto auto auto',
              md: 'auto auto auto auto',
            },
            gridGap: '10px',
          }}
        >
          {_.map(statuses, status => (
            <StatusToggleButton
              sx={{ width: buttonWidth }}
              value={status?.inspectionResultTypeId}
              key={status?.inspectionResultTypeId}
            >
              <Typography>{status?.title}</Typography>
            </StatusToggleButton>
          ))}
        </ToggleButtonGroup>
      </Stack>
      <Stack spacing={1}>
        <TextAreaInput
          form={form}
          isRequired={false}
          label="점검내용"
          fieldPath="inspectionNote"
          placeholder="예시 : 점검 내용 추가 작성"
        />
      </Stack>
    </>
  );
}
